{
 "notes": "Crew boss job (docs/BOSSES.md). hp is for a crew of 2; crewScale[n-1] multiplies it at spawn. Attack ranges/radii in px, times in s. loot.minRarity is the floor for the best roll; rarityBoost shifts the weapon roll toward rarer tiers.",
 "crewScale": [0.6, 1, 1.4, 1.8],
 "cooldownSec": 180,
 "warningSec": 10,
 "creditWindowSec": 60,
 "rewardFloor": 0.25,
 "carDamageMult": 0.4,
 "carRecoil": 0.5,
 "tiers": {
  "brute": {
   "tier": 1, "name": "Goro the Gate", "credNeeded": 50, "radius": 13, "hp": 2000, "speed": 60, "timeLimit": 300, "electronic": false,
   "wide": false, "escorts": { "kind": "gang", "count": 4 },
   "phases": [0.66, 0.33],
   "reward": { "money": 900, "xp": 400, "cred": 8 },
   "loot": { "rolls": 1, "minRarity": "uncommon", "rarityBoost": 0.1 },
   "attacks": {
    "smash": { "damage": 28, "range": 26, "radius": 28, "windup": 0.7, "cooldown": 1.8 },
    "shotgun": { "damage": 7, "range": 160, "pellets": 6, "spread": 0.35, "windup": 0.5, "cooldown": 2.2 }
   }
  },
  "mech": {
   "tier": 2, "name": "Tetsu-Kamen Mech Walker", "credNeeded": 75, "radius": 20, "hp": 4500, "speed": 44, "timeLimit": 420, "electronic": true,
   "wide": false, "escorts": { "kind": "gang", "count": 3 },
   "phases": [0.66, 0.33],
   "reward": { "money": 2200, "xp": 900, "cred": 18 },
   "loot": { "rolls": 2, "minRarity": "rare", "rarityBoost": 0.25 },
   "attacks": {
    "guns": { "damage": 5, "range": 260, "pellets": 1, "spread": 0.12, "burst": 8, "windup": 0.6, "cooldown": 3 },
    "charge": { "damage": 30, "range": 220, "radius": 18, "windup": 1.1, "cooldown": 6 },
    "mortar": { "damage": 26, "range": 300, "radius": 34, "shells": 5, "windup": 1.4, "cooldown": 8 }
   }
  },
  "kaiju": {
   "tier": 3, "name": "NeonG", "credNeeded": 100, "radius": 34, "hp": 14000, "speed": 30, "timeLimit": 600, "electronic": false,
   "wide": true, "escorts": { "kind": "gang", "count": 0 },
   "phases": [0.66, 0.33],
   "reward": { "money": 6000, "xp": 2200, "cred": 40 },
   "loot": { "rolls": 3, "minRarity": "epic", "rarityBoost": 0.45 },
   "attacks": {
    "stomp": { "damage": 34, "range": 60, "radius": 90, "windup": 1.2, "cooldown": 5 },
    "tail": { "damage": 28, "range": 80, "arc": 2.6, "windup": 0.9, "cooldown": 4 },
    "breath": { "damage": 18, "range": 240, "arc": 0.7, "duration": 2, "windup": 1.6, "cooldown": 9 }
   }
  }
 }
}
